import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import {
    downLoadCarTemplateFile,
    exportCarXLXS
} from '../../../api/config/modules/VehicleFiles'
import moment from "moment";
export default {
    name: 'VehicleFiles',
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                category: '0',
                deviceNum: '',
                chargeType: '',
                chargeState: '',
                chargeRemark: '',
            },
            categoryList: [
                {
                    id: '0',
                    name: this.$t('common.carId')
                },
                {
                    id: '1',
                    name: this.$t('common.externalNumber')
                },
            ],
            chargeTypeList: [
                {
                    id: '',
                    name: this.$t('common.search.whole')
                },
                {
                    id: '0',
                    name: this.$t('EquipmentRenewal.charge')
                },
                {
                    id: '1',
                    name: this.$t('EquipmentRenewal.noCharge')
                }
            ],
            chargeStateList: [
                {
                    id: '',
                    name: this.$t('common.search.whole')
                },
                {
                    id: '0',
                    name: this.$t('common.normal')
                },
                {
                    id: '1',
                    name: this.$t('common.nearTime')
                },
                {
                    id: '2',
                    name: this.$t('common.exceedTime')
                }
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "categoryStr",
                label: this.$t('EquipmentRenewal.type'),
                align: "center",
                width: "120px"
            },
            {
                prop: "deviceNum",
                label: this.$t('common.num'),
                align: "center",
                width: "150px"
            },
            {
                prop: "useState",
                label: this.$t('EquipmentRenewal.usageStatus'),
                align: "center",
                width: "150px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.useState === '' ? '' : params.row.useState === 0 ? 'success' : 'info' }
                    }, params.row.useState === '' ? '' : params.row.useState === 0 ? this.$t('common.normal') : this.$t('common.scrap'))
                }
            },
            {
                prop: "chargeTypeStr",
                label: this.$t('EquipmentRenewal.feeType'),
                align: "center",
                width: "120px"
            },
            {
                prop: "chargeRemark",
                label: this.$t('EquipmentRenewal.feeRemarks'),
                align: "center",
                width: "120px"
            },
            {
                prop: "chargeStandard",
                label: this.$t('EquipmentRenewal.feeStandards'),
                align: "center",
                width: "160px"
            },
            {
                prop: "chargeStartDate",
                label: this.$t('EquipmentRenewal.chargeStartDate'),
                align: "center",
                width: "160px"
            },
            {
                prop: "chargeDate",
                label: this.$t('EquipmentRenewal.lastPaymentDate'),
                align: "center",
                width: "120px"
            },
            {
                prop: "dueDate",
                label: this.$t('EquipmentRenewal.expirationDate'),
                align: "center",
                width: "140px"
            },
            {
                prop: "chargeState",
                label: this.$t('EquipmentRenewal.chargingStatus'),
                align: "center",
                width: "160px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.chargeState === '' ? '' : params.row.chargeState === 0 ? 'success' : params.row.chargeState === 1 ? 'warning' : 'danger' }
                    }, params.row.chargeState === '' ? '' : params.row.chargeState === 0 ? this.$t('common.normal') : params.row.chargeState === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                }
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            typeList: [],
            dialogFormVisible: false,
            formLabelWidth: '80px',
            diaTitle: '',
            btnType: '',
            rules: {
                category: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.imputCarid'),
                    trigger: 'blur'
                }],
            },
            form: {
                category: '',
                upload: '',
                uploads: '',
            },

            // dialogTransferFormVisible: false,
            LabelWidth: '104px',
            // TransferRules: {},
            // TransferForm: {
            //     carId: '',
            //     roleId: ''
            // },
            // BindRules: {},
            // BindForm: {
            //     carId: '',
            //     terminalId: ''
            // },
            selected: [],
            id: '',
            name: '',
            // dialogBatchFormVisible: false,
            // dialogBindFormVisible: false,

            ChangeForm: {
                chargeType: '',
                chargeRemark: '',
                chargeStandard: ''
            },
            ChangeRules: {
                chargeType: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.brandId'),
                    trigger: 'change'
                }],
                chargeStandard: [{
                    required: true,
                    message: this.$t('VehicleManagement.form.manufactureNum'),
                    trigger: 'blur'
                }],

            },
            dialogChangeFormVisible: false,
            // ChangeCarForm: {
            //     carId: '',
            //     newCarId: ''
            // },
            // ChangeCarRules: {},
            // dialogCarFormVisible: false,
            // checkAll: false,
            // checkedCities: [],
            // parts: [],
            // isIndeterminate: false,
            // isShow: true,
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAllCar()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllCar()
        },
        getAllCar() {
            let param = {
                orgId: this.id,
                category: this.formInline.category,
                deviceNum: this.formInline.deviceNum,
                chargeType: this.formInline.chargeType,
                chargeState: this.formInline.chargeState,
                chargeRemark: this.formInline.chargeRemark,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('EquipmentRenewal/GET_SELECTRENEW', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllCar()
        },
        onClear() {
            this.formInline = {
                category: '0',
                deviceNum: '',
                chargeType: '',
                chargeState: '',
                chargeRemark: '',
            }
            this.getAllCar()
        },
        ImportRenewal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('EquipmentRenewal.batchRenewal')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        ImportScrap() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('EquipmentRenewal.batchScrapping')
            this.btnType = 'edit'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                // this.form.carId = this.selected[0].carId
                // this.form.customNum = this.selected[0].customNum
            })
        },
        uploadFile(e) {
            console.log(111)
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            this.form.upload = file
            // this.$nextTick(() => {
            //     this.$refs["formName"].clearValidate("uploadFile")
            // })
            // this.rules.uploadFile = []

        },
        uploadFiles(e) {
            console.log(222)
            let dom = document.getElementById('uploadDoms')
            let file = dom.files[0];
            this.form.uploads = file
            // this.$nextTick(() => {
            //     this.$refs["formName"].clearValidate("uploadFile")
            // })
            // this.rules.uploadFile = []

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.btnType == 'add') {
                        let formData = new FormData()
                        formData.append('category', this.form.category)
                        formData.append('file', this.form.upload)
                        this.$store.dispatch('EquipmentRenewal/GET_DEVICERENEW', formData).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        let formDataUpdate = new FormData()
                        formDataUpdate.append('category', this.form.category)
                        formDataUpdate.append('file', this.form.uploads)
                        this.$store.dispatch('EquipmentRenewal/GET_DEVICESCRAP', formDataUpdate).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }
                    // let param = {
                    //     category: this.form.category,

                    // }
                    // if (this.btnType == 'add') {
                    //     this.$store.dispatch('VehicleFiles/GET_INSERTCAR', param).then(res => {
                    //         if (res.data.code == 200) {
                    //             this.$message.success(this.$t('common.btn.addSuccess'))
                    //             this.dialogFormVisible = false;
                    //             this.getAllCar();
                    //             this.closeDia();
                    //         } else {
                    //             this.$message.error(res.data.msg)
                    //         }

                    //     }).catch(err => { })
                    // } else {
                    //     this.$store.dispatch('VehicleFiles/GET_UPDATECAR', param).then(res => {
                    //         if (res.data.code == 200) {
                    //             this.$message.success(this.$t('common.btn.editSuccess'))
                    //             this.dialogFormVisible = false;
                    //             this.getAllCar();
                    //             this.closeDia();
                    //         } else {
                    //             this.$message.error(res.data.msg)
                    //         }

                    //     }).catch(err => { })
                    // }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                category: '',
                file: '',
            }
        },
        closeDia() {
            this.form = {
                category: '',
                file: '',
            }
            this.dialogFormVisible = false;
        },

        TemplateDown() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/exportTemplate/exportRenewTemplate`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/exportTemplate/exportRenewTemplate`
                    location.href = url
                }
            }
        },
        scrapTemplateDown() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/exportTemplate/exportScrapTemplate`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/exportTemplate/exportScrapTemplate`
                    location.href = url
                }
            }
        },
        // transferCar() {
        //     this.dialogTransferFormVisible = true
        //     this.TransferForm.carId = ''
        //     this.selected.map(item => {
        //         if (this.selected.length > 1) {
        //             this.TransferForm.carId = this.TransferForm.carId.concat((item.carId + '-' + item.orgName + ','))
        //         } else {
        //             this.TransferForm.carId = this.TransferForm.carId.concat((item.carId + '-' + item.orgName))
        //         }
        //     })
        // },
        // changeClick(val) {
        //     this.roleId = val.label
        // },
        // submitTransferForm(TransferFormName) {
        //     this.$refs[TransferFormName].validate((valid) => {
        //         if (valid) {
        //             let carIds = ''
        //             this.selected.map((item, index) => {
        //                 if (index == 0) {
        //                     carIds = item.carId
        //                 } else {
        //                     carIds = carIds + ',' + item.carId
        //                 }
        //             })
        //             let param = {
        //                 carIds: carIds,
        //                 orgId: this.roleId
        //             }
        //             this.$store.dispatch('VehicleFiles/GET_BATCHCAR', param).then(res => {
        //                 if (res.data.code == 200) {
        //                     this.$message.success(this.$t('common.btn.transferSuccess'))
        //                     this.dialogTransferFormVisible = false;
        //                     this.getAllCar();
        //                     this.closeTransfer();
        //                 } else {
        //                     this.$message.error(res.data.msg)
        //                 }

        //             }).catch(err => { })
        //         } else {
        //             return false;
        //         }
        //     });
        // },
        // cancleTransfer(TransferFormName) {
        //     this.dialogTransferFormVisible = false;
        //     this.TransferForm = {
        //         carId: '',
        //         roleId: ''
        //     }
        // },
        // closeTransferDia() {
        //     this.TransferForm = {
        //         carId: '',
        //         roleId: ''
        //     }
        //     this.dialogTransferFormVisible = false;
        // },
        // bindCar() {
        //     this.dialogBindFormVisible = true;
        //     this.BindForm.carId = this.selected[0].carId
        //     this.BindForm.terminalId = this.selected[0].terminalId
        //     if (this.BindForm.terminalId) {
        //         this.isShow = true
        //     } else {
        //         this.isShow = false
        //     }
        // },
        // submitBindForm(BindFormName) {
        //     this.$refs[BindFormName].validate((valid) => {
        //         if (valid) {
        //             let param = {
        //                 type: 1,
        //                 carId: this.BindForm.carId,
        //                 terminalId: this.BindForm.terminalId
        //             }
        //             this.$store.dispatch('VehicleFiles/GET_CARBIND', param).then(res => {
        //                 if (res.data.code == 200) {
        //                     this.$message.success(this.$t('common.btn.bindSuccess'))
        //                     this.dialogBindFormVisible = false;
        //                     this.getAllCar();
        //                     this.closeBind();
        //                 } else {
        //                     this.$message.error(res.data.msg)
        //                 }

        //             }).catch(err => { })
        //         } else {
        //             return false;
        //         }
        //     });
        // },
        // cancleBind(BindFormName) {
        //     this.dialogBindFormVisible = false;
        //     this.BindForm = {
        //         carId: '',
        //         terminalId: ''
        //     }
        // },
        // closeBindDia() {
        //     this.BindForm = {
        //         carId: '',
        //         terminalId: ''
        //     }
        //     this.dialogBindFormVisible = false;
        // },

        changeType() {
            this.dialogChangeFormVisible = true
            this.ChangeForm.chargeType = String(this.selected[0].chargeType)
            this.ChangeForm.chargeRemark = this.selected[0].chargeRemark
            this.ChangeForm.chargeStandard = this.selected[0].chargeStandard
        },
        cancleChange(ChangeFormName) {
            this.dialogChangeFormVisible = false;
            this.ChangeForm = {
                chargeType: '',
                chargeRemark: '',
                chargeStandard: ''
            }
        },
        closeChangeDia() {
            this.ChangeForm = {
                chargeType: '',
                chargeRemark: '',
                chargeStandard: ''
            }
            this.dialogChangeFormVisible = false;
        },
        submitChangeForm(ChangeFormName) {
            this.$refs[ChangeFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        deviceNum: this.selected.map(item => item.deviceNum).join(),
                        chargeType: this.ChangeForm.chargeType,
                        chargeRemark: this.ChangeForm.chargeRemark,
                        chargeStandard: this.ChangeForm.chargeStandard
                    }
                    this.$store.dispatch('EquipmentRenewal/GET_UPDATERENEW', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('EquipmentRenewal.changeSuccessful'))
                            this.dialogBindFormVisible = false;
                            this.getAllCar();
                            this.closeChangeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },


        BulkImport() {
            this.dialogBatchFormVisible = true
        },

        // TemplateFile() {
        //     if (domainName) {
        //         if (domainName.split(':')[0] !== 'localhost') {
        //             let url = `https://${domainName}/v1/getExportExcel/exportCarModel`
        //             location.href = url
        //         } else {
        //             let host = 'localhost:8080'
        //             let url = `https://${host}/v1/getExportExcel/exportCarModel`
        //             location.href = url
        //         }
        //     }
        // },

        // uploadCar(e) {
        //     let dom = document.getElementById('uploadDom')
        //     let file = dom.files[0];
        //     let companyId = sessionStorage.getItem('companyId')
        //     let userId = sessionStorage.getItem('userId')
        //     let orgId = this.id
        //     let formData = new FormData()
        //     formData.append('File', file)
        //     formData.append('userId', userId)
        //     formData.append('companyId', companyId)
        //     formData.append('orgId', orgId)
        //     let types = file.name.split('.')[1]
        //     if (types != "xlsx" && types != "xls") {
        //         this.$message.error(this.$t('common.btn.choseExcelFile'));
        //         return false;
        //     } else {
        //         this.$store.dispatch('VehicleFiles/GET_UPLOADCAR', formData).then(res => {
        //             if (res.data.code == 200) {
        //                 this.$message.success(this.$t('common.btn.fileUploadSuccess'))
        //                 this.dialogBatchFormVisible = false;
        //                 this.getAllCar()
        //             } else {
        //                 this.$message.error(res.data.msg)
        //             }
        //             document.getElementById('uploadDom').value = ''
        //         }).catch(err => {
        //             this.$message.error(this.$t('common.btn.fileUploadError'))
        //             document.getElementById('uploadDom').value = ''
        //         })
        //     }
        // },
        // closeBatchDia() {
        //     this.dialogBatchFormVisible = false
        // },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportRenew?orgId=${this.id}&category=${this.formInline.category}&deviceNum=${this.formInline.deviceNum}&chargeType=${this.formInline.chargeType}&chargeRemark=${this.formInline.chargeRemark}&chargeState=${this.formInline.chargeState}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportRenew?orgId=${this.id}&category=${this.formInline.category}&deviceNum=${this.formInline.deviceNum}&chargeType=${this.formInline.chargeType}&chargeRemark=${this.formInline.chargeRemark}&chargeState=${this.formInline.chargeState}`
                    location.href = url


                }
            }
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllCar();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}